export interface ApiGetRelatedIpcRequest {
    type: string;
    text: string;
}

export type ApiGetRelatedIpcResponse = { code: string, desc: string }[];

export const GetRelatedIpc = Symbol('GetRelatedIpc');

export interface GetRelatedIpc {
    getRelatedIpc(data: ApiGetRelatedIpcRequest): Promise<ApiGetRelatedIpcResponse>;
}